module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAkCAYAAAC9itu8AAAAAXNSR0IArs4c6QAAAMJJREFUOE9j/L+I9wQDCYDx/yLeQySoZ2D8v5BnNwMDEwMDwz8GYmjG/wt5tzIwMjAw/GdgIIZm/L+Adz2JTuJbRZqG+XxLSdWwiCQNf+cKkKhhtjBpTvozTXQtSU76M1liB2kaJkgfJUnD7x65KyRp+NOp+JAkDb/bld+QpOFXq+oXkjT8bFb9RZKGX01qf0jS8LNRA5RziAaMPxs0SdRQpwXKa0QDxp+12iRqqNEhTcP3IpNRDYQihHE0lAgFEVAeAI88ZLYWHaWKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/home/y_title.png
// module id = KJFb
// module chunks = 101